/**
 * Feature flags — toggle whole features on/off from one place.
 *
 * Flip to `false` and the corresponding UI entry points (nav link,
 * homepage CTA, product-page button) disappear without touching the
 * underlying page or route. The route itself is left mounted so any
 * bookmarked URL still works if flipped back on.
 */
export const FEATURES = {
  designEditor: true,
} as const;
